import { render, staticRenderFns } from "./InstructionAlert.vue?vue&type=template&id=e88cee16&scoped=true&"
import script from "./InstructionAlert.vue?vue&type=script&lang=js&"
export * from "./InstructionAlert.vue?vue&type=script&lang=js&"
import style0 from "./InstructionAlert.vue?vue&type=style&index=0&id=e88cee16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88cee16",
  null
  
)

export default component.exports